<h2 mat-dialog-title>
  {{ mandatory ? 'Selecione sua filial' : 'Trocar filial' }}
</h2>

<mat-dialog-content>
  <p class="subtitle" *ngIf="mandatory">
    Seu usuário tem acesso a mais de uma filial. Selecione a filial com que deseja trabalhar agora.
  </p>

  <mat-radio-group [(ngModel)]="selectedBranchId" class="branch-list">
    <mat-radio-button
      *ngFor="let branch of branches"
      [value]="branch.id"
      class="branch-option"
    >
      {{ branch.name }}
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    type="button"
    *ngIf="!mandatory"
    (click)="cancel()"
    [disabled]="loading"
  >
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="onConfirm()"
    [disabled]="!selectedBranchId || loading"
  >
    <mat-spinner *ngIf="loading" diameter="18" style="display:inline-block; margin-right:6px;"></mat-spinner>
    Confirmar
  </button>
</mat-dialog-actions>
